<template>
    <div class="flex items-center justify-center inset-0 fixed bg-black/50 backdrop-blur-sm z-40 overflow-hidden">
        <div class="p-6 glass-card mb-2 w-[80%] max-h-[80vh] overflow-y-auto shadow-xl z-50">
            <div class="flex items-center justify-between mb-4">
                <h4 class="text-lg font-semibold text-gray-900 dark:text-white flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="mr-2">
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
                </svg>
                SNMP Target
                </h4>
                <button
                type="button"
                @click="$emit('remove')"
                class="text-red-500 hover:text-red-700 hover:bg-transparent bg-transparent p-2"
                >
                <Trash/>
                </button>
            </div>

            <div class="grid grid-cols-2 gap-4">
                <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-white mb-2">
                    Target Name
                </label>
                <input
                    v-model="localTarget.name"
                    @input="updateTarget"
                    type="text"
                    placeholder="Router"
                    class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                </div>

                <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-white mb-2">
                    Target IP
                </label>
                <input
                    v-model="localTarget.target_ip"
                    @input="updateTarget"
                    type="text"
                    placeholder="192.168.25.1"
                    class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                </div>

                <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-white mb-2">
                    Port
                </label>
                <input
                    v-model.number="localTarget.port"
                    @input="updateTarget"
                    type="number"
                    placeholder="161"
                    class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                </div>

                <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-white mb-2">
                    Community
                </label>
                <input
                    v-model="localTarget.community"
                    @input="updateTarget"
                    type="text"
                    placeholder="split001"
                    class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                </div>

                <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-white mb-2">
                    Interface Index
                </label>
                <input
                    v-model.number="localTarget.interface_index"
                    @input="updateTarget"
                    type="number"
                    placeholder="Optional"
                    class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                </div>

                <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-white mb-2">
                    Poll Interval (seconds)
                </label>
                <input
                    v-model.number="localTarget.poll_interval_sec"
                    @input="updateTarget"
                    type="number"
                    placeholder="60"
                    class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                </div>

                <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-white mb-2">
                    Timeout (ms)
                </label>
                <input
                    v-model.number="localTarget.timeout_ms"
                    @input="updateTarget"
                    type="number"
                    placeholder="3000"
                    class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                </div>
            </div>

            <div class="space-y-3 mt-3">
                <div class="flex items-center">
                <input
                    v-model="localTarget.walk_all_interfaces"
                    @change="updateTarget"
                    type="checkbox"
                    class="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label class="ml-3 text-sm font-medium text-gray-900 dark:text-white">
                    Walk All Interfaces
                </label>
                </div>

                <div class="flex items-center">
                <input
                    v-model="localTarget.use_64bit_counters"
                    @change="updateTarget"
                    type="checkbox"
                    class="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label class="ml-3 text-sm font-medium text-gray-900 dark:text-white">
                    Use 64-bit counters (HC)
                </label>
                </div>

                <div class="flex items-center">
                <input
                    v-model="localTarget.enabled"
                    @change="updateTarget"
                    type="checkbox"
                    class="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label class="ml-3 text-sm font-medium text-gray-900 dark:text-white">
                    Enabled
                </label>
                </div>
            </div>

            <div class="mt-3">
                <label class="block text-sm font-medium text-gray-700 dark:text-white mb-2">
                Description
                </label>
                <textarea
                v-model="localTarget.description"
                @input="updateTarget"
                placeholder="Optional description"
                rows="2"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                ></textarea>
            </div>

            <div class="mt-6">
                <div class="flex items-center justify-between mb-3">
                <label class="text-sm font-medium text-gray-900 dark:text-white">
                    Custom OIDs
                </label>
                <button
                    type="button"
                    @click="addCustomOid"
                    class="text-blue-600 dark:text-blue-400 hover:text-blue-700 text-sm flex items-center gap-1"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/>
                    </svg>
                    Add OID
                </button>
                </div>

                <div v-if="localTarget.custom_oids && localTarget.custom_oids.length > 0" class="space-y-4">
                <div
                    v-for="(oid, index) in localTarget.custom_oids"
                    :key="index"
                    class="border border-gray-200 dark:border-gray-700 rounded p-4 bg-gray-50 dark:bg-gray-900"
                >
                    <div class="flex justify-between items-start mb-3">
                    <h5 class="text-sm font-medium text-gray-900 dark:text-white">Custom OID {{ index + 1 }}</h5>
                    <button
                        type="button"
                        @click="removeCustomOid(index)"
                        class="text-red-500 hover:text-red-700"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                        </svg>
                    </button>
                    </div>

                    <div class="grid grid-cols-2 gap-3">
                    <div>
                        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Name
                        </label>
                        <input
                        v-model="oid.name"
                        @input="updateTarget"
                        type="text"
                        class="w-full px-2 py-1.5 text-sm border border-gray-300 dark:border-gray-600 dark:bg-gray-800 dark:text-white rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div>
                        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
                        OID
                        </label>
                        <input
                        v-model="oid.oid"
                        @input="updateTarget"
                        type="text"
                        class="w-full px-2 py-1.5 text-sm border border-gray-300 dark:border-gray-600 dark:bg-gray-800 dark:text-white rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div>
                        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Type
                        </label>
                        <GlassSelect
                        v-model="oid.type"
                        @change="updateTarget"
                        :options="['gauge', 'counter', 'counter64']"
                        />
                    </div>

                    <div>
                        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Metric Name
                        </label>
                        <input
                        v-model="oid.metric_name"
                        @input="updateTarget"
                        type="text"
                        class="w-full px-2 py-1.5 text-sm border border-gray-300 dark:border-gray-600 dark:bg-gray-800 dark:text-white rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div class="col-span-2">
                        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Description
                        </label>
                        <input
                        v-model="oid.description"
                        @input="updateTarget"
                        type="text"
                        class="w-full px-2 py-1.5 text-sm border border-gray-300 dark:border-gray-600 dark:bg-gray-800 dark:text-white rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    </div>
                </div>
                </div>
            </div>

            <div class="flex justify-end gap-2 mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
                <button
                type="button"
                @click="$emit('cancel')"
                class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700"
                >
                Cancel
                </button>
                <button
                type="button"
                @click="saveTarget"
                :disabled="saving"
                class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                {{ saving ? 'Saving...' : 'Save Target' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { Trash } from 'lucide-vue-next';
import GlassSelect from "@/components/GlassSelect.vue";

const props = defineProps({
  target: {
    type: Object,
    required: true
  },
  deviceId: {
    type: String,
    required: true
  }
});

const emit = defineEmits(['saved', 'cancel', 'remove']);

const localTarget = ref({ ...props.target });
const saving = ref(false);

// Watch for prop changes from parent
watch(() => props.target, (newTarget) => {
  localTarget.value = { ...newTarget };
}, { deep: true });

const updateTarget = () => {
  // Just update local state, don't emit yet
};

const addCustomOid = () => {
  if (!localTarget.value.custom_oids) {
    localTarget.value.custom_oids = [];
  }
  localTarget.value.custom_oids.push({
    name: '',
    oid: '',
    type: 'gauge',
    metric_name: '',
    description: ''
  });
};

const removeCustomOid = (index) => {
  localTarget.value.custom_oids.splice(index, 1);
};

const saveTarget = async () => {
  saving.value = true;
  try {
    // Emit the target data to parent which will handle the API call
    emit('saved', localTarget.value);
  } catch (error) {
    console.error('Error in saveTarget:', error);
  } finally {
    saving.value = false;
  }
};
</script>